/* eslint-disable import/no-cycle */
import { Stack, HStack } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormTextInput from '../formInputs/FormTextInput';
import { FormBuilderComponentProps } from '../types';
import ComponentButtonPreview from './ComponentButtonPreview';
import { useStoreState } from '../../../../models/hooks';

function ImageFieldComponent({ fieldId, isAdvanced, labelRightRenderer }: Omit<FormBuilderComponentProps, 'path'>) {
  const { t } = useTranslation('hrFormTemplate');
  const currentLanguage = useStoreState((state) => state.formBuilder.currentLanguage);

  return (
    <Stack>
      <HStack justify="space-between">
        <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
        {labelRightRenderer}
      </HStack>
      <FormTextInput fieldId={fieldId} placeholder={t('formBuilder.editorPlaceholder.image')} isAdvanced={isAdvanced || false} />
      <HStack>
        <ComponentButtonPreview label={t('formBuilder.chooseAFile', { lng: currentLanguage })} />
        <ComponentButtonPreview label={t('formBuilder.openCamera', { lng: currentLanguage })} />
      </HStack>
    </Stack>
  );
}

export const ImageField = React.memo(
  ImageFieldComponent,
  (prev, next) =>
    /* eslint-disable-next-line  */
    prev.fieldId === next.fieldId && prev.isAdvanced === next.isAdvanced && prev.labelRightRenderer === next.labelRightRenderer,
);
